import { useContext, useState } from "react";
import { Button, IconGoogle } from "../../../../components/atoms";
import { InputGroup } from "../../../../components/molecules";
import { AuthContext } from "../../../../contexts/Auth/AuthContext";
import { NotificationContext } from "../../../../contexts/NotificationCTX/NotificationContext";
import { api } from "../../../../helpers";

export function FormEmployee() {
  const {
    setType,
    setShow,
    setText: setTextAlert,
  } = useContext(NotificationContext);

  const { applicationData } = useContext(AuthContext);
  const [campoObrigatorioNome, setcampoObrigatorioNome] =
    useState<boolean>(false);
  const [campoObrigatorioTelefone, setcampoObrigatorioTelefone] =
    useState<boolean>(false);
  const [campoObrigatorioCNPJ, setcampoObrigatorioCNPJ] =
    useState<boolean>(false);
  const [campoObrigatorioEndereco, setcampoObrigatorioEndereco] =
    useState<boolean>(false);
  const [campoObrigatorioBairro, setcampoObrigatorioBairro] =
    useState<boolean>(false);
  const [campoObrigatorioNumero, setcampoObrigatorioNumero] =
    useState<boolean>(false);

  const [nome, setNome] = useState("");
  const [telefone, setTelefone] = useState("");
  const [cpf, setCpf] = useState("");
  const [cidade, setCidade] = useState("");
  const [endereco, setEndereco] = useState("");
  const [bairro, setBairro] = useState("");
  const [numero, setNumero] = useState("");
  const [email, setEmail] = useState("");
  const [cep, setCep] = useState("");
  const [obs, setObs] = useState("");

  const gravar = async () => {
    let useradd = applicationData.funcionario;
    let filial = 7;
    let empresa = 7;
    const response = await api.post("/api/funcionario/addjson", {
      nome,
      telefone,
      cpf,
      cidade,
      endereco,
      bairro,
      numero,
      email,
      cep,
      obs,
      useradd,
      filial,
      empresa,
    });
    if (response.status === 200) {
      setType("success");
      setTextAlert(response.statusText);
      setShow(true);
    }
  };

  return (
    <div>
      <h2>Incluir Funcionario</h2>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-6">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Nome"
            messageError={campoObrigatorioNome ? "Campo obrigatório!" : ""}
            id="nome"
            type="string"
            value={nome}
            maxLength={50}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioNome(true);
              else {
                setNome(e.target.value);
                setcampoObrigatorioNome(false);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="CPF"
            messageError={campoObrigatorioCNPJ ? "Campo obrigatório!" : ""}
            id="cpf"
            type="string"
            value={cpf}
            maxLength={11}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioCNPJ(true);
              else {
                setCpf(e.target.value);
                setcampoObrigatorioCNPJ(false);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Telefone"
            messageError={campoObrigatorioTelefone ? "Campo obrigatório!" : ""}
            id="telefone"
            type="string"
            value={telefone}
            maxLength={14}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioTelefone(true);
              else {
                setTelefone(e.target.value);
                setcampoObrigatorioTelefone(false);
              }
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Email"
            id="email"
            type="string"
            value={email}
            maxLength={50}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "") setEmail(e.target.value);
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-6">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Endereco"
            messageError={campoObrigatorioEndereco ? "Campo obrigatório!" : ""}
            id="endereco"
            type="string"
            value={endereco}
            maxLength={100}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioEndereco(true);
              else {
                setEndereco(e.target.value);
                setcampoObrigatorioEndereco(false);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Numero"
            messageError={campoObrigatorioNumero ? "Campo obrigatório!" : ""}
            id="numero"
            type="string"
            value={numero}
            maxLength={5}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioNumero(true);
              else {
                setNumero(e.target.value);
                setcampoObrigatorioNumero(false);
              }
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Bairro"
            messageError={campoObrigatorioBairro ? "Campo obrigatório!" : ""}
            id="bairro"
            type="string"
            value={bairro}
            maxLength={40}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioBairro(true);
              else {
                setBairro(e.target.value);
                setcampoObrigatorioBairro(false);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Cep"
            id="cep"
            type="string"
            value={cep}
            minLength={8}
            maxLength={8}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "") setCep(e.target.value);
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-6">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Cidade"
            id="cidade"
            type="string"
            value={cidade}
            maxLength={40}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "") setCidade(e.target.value);
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-12">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Observacao"
            messageError={campoObrigatorioNome ? "Campo obrigatório!" : ""}
            id="obs"
            type="string"
            value={obs}
            maxLength={70}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "") setObs(e.target.value);
            }}
          />
        </div>
      </div>

      <div className="row mt-3"></div>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-2">
          <Button
            appearance="success"
            onClick={() => {
              gravar();
            }}
          >
            Gravar<IconGoogle>save</IconGoogle>
          </Button>
        </div>
      </div>
    </div>
  );
}
